export const Legal = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 9.01953H3V3.01953L9 9.01953Z"
      fill="url(#paint0_linear_5960_17606)"
    />
    <path
      d="M12 0.0195312H0L3 3.01953L9 3.01953L9 9.01953L12 12.0195V0.0195312Z"
      fill="url(#paint1_linear_5960_17606)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5960_17606"
        x1="3"
        y1="6.01953"
        x2="9"
        y2="6.01953"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5960_17606"
        x1="0"
        y1="6.01953"
        x2="12"
        y2="6.01953"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
